package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import kotlin.math.abs

val panelSize = Vector3f(4f, 0f, 4f)

val bottomLeftPanelCenter = Vector3f(x=272f,y=8f,z=316f)

val enemyPrepFinalWestCenter = Vector3f(x=278f,y=8f,z=338f)
val enemyPrepFinalEastCenter = Vector3f(x=282f,y=8f,z=338f)

val panelZoneObjectIdLayout = listOf(
    listOf(1333, 1327, 1321, 1329, 1320), // Nearest
    listOf(1405, 1404, 1323, 1322, 1402),
    listOf(1334, 1325, 1400, 1324, 1403),
    listOf(1336, 1331, 1401, 1332, 1330),
    listOf(1335, 1328, 1398, 1399, 1326), // Farthest
)

data class Position(val x: Int, val y: Int)

sealed interface CursorPosition {
    fun toWorldSpace(): Vector3f
}

data class PanelPosition(val position: Position): CursorPosition {
    constructor(x: Int, y: Int): this(Position(x, y))

    companion object {
        fun maybe(x: Int, y: Int): PanelPosition? {
            if (x < 0 || x > 4) { return null }
            if (y < 0 || y > 4) { return null }
            return PanelPosition(x, y)
        }
    }

    init {
        check(position.x in 0..4)
        check(position.y in 0..4)
    }

    val x: Int
        get() = position.x

    val y: Int
        get() = position.y

    override fun toWorldSpace(): Vector3f {
        return bottomLeftPanelCenter + Vector3f(panelSize.x * x, 0f, panelSize.z * y)
    }

    fun distance(other: PanelPosition): Int {
        return abs(other.x - x) + abs(other.y - y)
    }

    fun isDiagonal(other: PanelPosition): Boolean {
        return x != other.x && y != other.y
    }
}

object PlayerPrepPosition: CursorPosition {
    override fun toWorldSpace(): Vector3f {
        return Vector3f(x=280f,y=8.00f,z=312f)
    }
}

data class EnemyPrepPosition(val position: Position): CursorPosition {

    companion object {
        private val rampPositions = listOf(
            Vector3f(x=280f,y=7.25f,z=344f),
            Vector3f(x=280f,y=5.46f,z=348f),
            Vector3f(x=280f,y=3.79f,z=352f),
            Vector3f(x=280f,y=3.00f,z=356f),
        )
    }

    constructor(x: Int, y: Int): this(Position(x, y))

    init {
        check(position.y in 0..4)
        if (position.y == 0) {
            check(position.x in 0..1)
        } else {
            check(position.x == 0)
        }
    }

    val x: Int
        get() = position.x

    val y: Int
        get() = position.y

    override fun toWorldSpace(): Vector3f {
        return if (y == 0) {
            if (x == 0) { enemyPrepFinalWestCenter } else { enemyPrepFinalEastCenter }
        } else {
            rampPositions[y - 1]
        }
    }
}
